import { Button, Card, CardActions, CardContent, Grid2 as Grid, Typography} from "@mui/material";
import { SaleHistory, Transaction } from "../types";

type Props = {
  sale: SaleHistory;
}

function SaleCard(props: Props) {

  const currencyPrinter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
  });

  return (<Card sx={{backgroundColor: "#e0f1ff"}}>
    <CardContent>
      <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
        {props.sale.saleDate}
      </Typography>
      <Typography variant="body2">
        <b>Price:</b>&nbsp;{currencyPrinter.format(props.sale.price)}
      </Typography>
      <Typography variant="body2">
        <b>Grantor:</b>&nbsp;{props.sale.grantor}
      </Typography>
      <Typography variant="body2">
        <b>Grantee:</b>&nbsp;{props.sale.grantee}
      </Typography>
      <Typography variant="body2">
        <b>Deed Type:</b>&nbsp;{props.sale.deedType}
      </Typography>
    </CardContent>
  </Card>);
}

export default SaleCard;
